<template lang="pug">
  #InvitationIndex.container-width
    h4.pt-3.text-center {{ invitation.invite_title }}
    img.img-fluid.w-100.rounded(:src="invitation.invite_picture_url")
    .text-center(v-html='invitation.invite_content')
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'InvitationIndex',
  data() {
    return {
      id: null
    };
  },
  created() {
    const vm = this;
    vm.id = vm.$route.params.id;

    if (vm.id !== undefined && vm.id !== null) {
      window.sessionStorage.setItem('invite_id', vm.id);
    }
    const data = {
      id : window.sessionStorage.getItem('invite_id')
    }

    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('member_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('member_invitation/getInvitationHandler', data);
  },
  methods: {
  },
  computed: {
    ...mapState({
      invitation: (state) => state.member_invitation.invitation,
    })
  }
};
</script>

<style>

</style>
